// extracted by mini-css-extract-plugin
export var bodyRow = "_f1-d";
export var cardColumns = "_f1-e";
export var ellipsesOverflow = "_f1-2";
export var flatBottomCorners = "_f1-3";
export var flatTopCorners = "_f1-4";
export var headerActionsDropdown = "_f1-f";
export var headerBottomRow = "_f1-c";
export var headerTopRow = "_f1-b";
export var orderDetailsWrapper = "_f1-0";
export var orderInfoContainer = "_f1-1";
export var productDetails = "_f1-9";
export var productImage = "_f1-5";
export var responsiveTable = "_f1-8";
export var shipmentContainer = "_f1-a";
export var tableBottomLeft = "_f1-6";
export var tableBottomRight = "_f1-7";